﻿import { createFocusTrap } from "./focus-trap.js";

const Panel = function panel(name, container, options = null) {
    //if (container) container.classList.remove('nojs');
    if (container) {
        container.classList.remove('nojs');
        container.style.position = 'static';
        setTimeout(() => {
            container.style.removeProperty('position');
        }, 300);
    }
    const settings = {
        name: name,
        container: container,
        panel: undefined,
        closeBtns: undefined,
        openBtns: undefined,
        trap: undefined,
        onopen: undefined,
        onclose: undefined,
        instance: undefined,
        onready: undefined,
        dismissible: true,
        initialFocus: undefined,
        get panelName() { return this.name; },
        get fallbackFocus() { return panelInstance.el.panel.querySelector('[data-panel-content]'); },
        get focusTrapConfig() {
            return {
                initialFocus: settings.initialFocus,
                fallbackFocus: settings.fallbackFocus,
                escapeDeactivates: () => {
                    if (settings.dismissible) panelInstance.close();
                    return false;
                },
                clickOutsideDeactivates: () => {
                    if (settings.dismissible) panelInstance.close();
                    return false;
                }
            }
        }
    }
    let windowTop = 0;
    const focusTrapSettings = {
        get initialFocus() { return settings.initialFocus },
        get fallbackFocus() { return settings.fallbackFocus },
        get escapeDeactivates() {
            if (settings.dismissible) panelInstance.close();
            return false;
        },
        get clickOutsideDeactivates() {
            //const btn = arguments[0].originalTarget.matches('[data-panel="nav"]');
            //console.log(btn);
            //if (btn) { return false; }
            if (settings.dismissible) panelInstance.close();
            return false;
        }
    }
    const self = this;
    const ext = {
        get settings() { return settings; },
        get instance() { return panelInstance; },
        el: {
            get container() {
                return settings.container
            },
            get panel() {
                return settings.panel
            }
        },
        registerCallback(evnt, instance, func) {
            settings.instance = panelInstance;
            settings[evnt] = func;
        },
        registerOnOpenCallback(instance, func) {
            ext.registerCallback("onopen", instance, func)
        },
        registerOnCloseCallback(instance, func) {
            ext.registerCallback("onclose", instance, func)
        },
        registerOnReadyCallback(instance, func) {
            ext.registerCallback("onready", instance, func)
        }
    }

    const isOpen = () => {
        return settings.panel.classList.contains('active');
    }

    const init = (name, container, _this) => {
        settings.container = container;
        settings.panel = document.querySelector('[data-panel-name="' + name + '"]');
        settings.closeBtns = container.querySelectorAll('[data-panel-close]');
        settings.openBtns = document.querySelectorAll(`[data-panel-open="${name}"]`);
        settings.openBtns.forEach(b => {
            b.removeEventListener('click', handleOpen);
            b.addEventListener('click', handleOpen.bind(panelInstance));
        });
        settings.initialFocus = settings.initialFocus || panelInstance.el.panel.querySelector('[data-panel-content]');
        if (container.dataset.dismissible == "false") settings.dismissible = false;
        //settings.trap = focusTrap.createFocusTrap(settings.container, {
        //    initialFocus: settings.initialFocus,
        //    escapeDeactivates: () => {
        //        if (settings.dismissible) close();
        //        return false;
        //    },
        //    clickOutsideDeactivates: () => {
        //        if (settings.dismissible) close();
        //        return false;
        //    }
        //});
        settings.trap = createFocusTrap(settings.container, settings.focusTrapConfig);
        if (typeof (settings.onready) == "function") {
            ext.registerOnReadyCallback(panelInstance, settings.onready);
        }
        if (typeof (settings.onopen) == "function") {
            ext.registerOnOpenCallback(panelInstance, settings.onopen);
        }
        if (typeof (settings.onclose) == "function") {
            ext.registerOnCloseCallback(panelInstance, settings.onclose);
        }
        return _this;
    }
    const open = () => {
        //console.log('Open')
        //console.log(history.state);
        //console.log('------------------------');

        const historyHasState = history.state && history.state.modalOpen && history.state.modelName == settings.name;

        windowTop = window.scrollY;
        document.querySelector('html').style.setProperty("--body-top", -windowTop + "px");

        settings.container.classList.add('active');
        settings.panel.classList.add('active');
        document.body.classList.add('no-scroll');
        if (typeof (settings.onopen) == "function") {
            settings.onopen(panelInstance);
        }
        addEventListeners(this);
        settings.trap.activate();
        if (!historyHasState) {
            history.pushState({ modalOpen: true, modelName: settings.name }, 'Modal open', '#' + settings.panel.id);
        }

        //console.log(history.state);
        //console.log('------------------------');
    }
    const close = () => {
        //if (!isOpen()) return;
        //console.log('Close')
        //console.log(history.state);
        //console.log('------------------------');
        settings.container.classList.remove('active');
        settings.panel.classList.remove('active');
        document.body.classList.remove('no-scroll');
        removeEventListeners();
        document.querySelector('html').style.scrollBehavior = "auto"
        window.scrollTo(0, windowTop);
        if (typeof (settings.onclose) == "function") {
            settings.onclose(panelInstance);
        }
        settings.trap.deactivate();
        document.querySelector('html').style.scrollBehavior = "smooth"
        if (history.state && history.state.modalOpen && history.state.modelName == settings.name) {
            history.back();  // This removes the modal from the history stack
        }
        //console.log(history.state);
        //console.log('------------------------');
    }
    const handleOpen = (e) => {
        e.preventDefault();
        open();
    }
    const handleClose = (e) => {
        e.preventDefault();
        close();
    }
    const handleContainerClick = (e) => {
        if (e.target.matches('[data-panel-overlay]')) {
            e.preventDefault();
            if (settings.dismissible) close();
        }
    }

    const addEventListeners = (_this) => {
        //const _this = this;
        settings.closeBtns.forEach(b => {
            b.addEventListener('click', handleClose);
        });
        settings.container.addEventListener('click', handleContainerClick);

    }
    const removeEventListeners = () => {
        settings.closeBtns.forEach(b => {
            b.removeEventListener('click', handleClose);
        })
        settings.container.removeEventListener('click', handleClose);
    }

    const create = (instance, options = null) => {
        if (options != null) {
            Object.entries(options).forEach(([key, val]) => {
                //console.log(`${key}:${val}`);
                if (settings.hasOwnProperty(key)) {
                    if (settings[key] != val) {
                        Reflect.set(settings, key, val);
                    }
                }
            });
        }
        init(name, container, instance);
        if (typeof (settings.onready) == "function") {
            settings.onready(panelInstance);
        }

    }

    //const _this = init(name, container);

    const panelInstance = {
        openHandler: handleOpen,
        closeHandler: handleClose,
        open: open,
        close: close,
        onopen: ext.registerOnOpenCallback,
        onclose: ext.registerOnCloseCallback,
        onready: ext.registerOnReadyCallback,
        registerCallback: ext.registerCallback,
        init: create,
        el: ext.el,
        settings: ext.settings,
        get isOpen() { return isOpen }
    }
    create(panel, options);

    // Handle back button navigation (or forward)
    window.addEventListener("popstate", (event) => {
        var modelName = event.state != null ? event.state.modelName.modelName : '';
        console.log('========================');
        console.log('popstate');
        console.log('name: ' + settings.name);
        console.log('state.modelName: ' + modelName);
        console.log('isOpen: ' + isOpen());
        console.log('------------------------');

        const shouldOpen = isOpen() != true;
        if (event.state && event.state.modelName != settings.name) {
            return;
        }
        if (event.state && event.state.modalOpen && event.state.modelName == settings.name) {
            if (shouldOpen) open();
            //if (shouldOpen) {
            //    // If the state is related to the modal being open, show the modal
            //    open();
            //} else {
            //    //close();
            //}
        } else {
            // If no modal-related state, ensure it's closed
            if (isOpen()) {
                close();
            }
        }
    });
    settings.instance = this.panelInstance;
    return panelInstance;
}

function PanelEnquiryObject(containerElement) {
    const
        container = containerElement.querySelector('.enquiry-object'),
        view = {
            img: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-img') },
                update: function (val) { data = val; this.elem.src = data; }
            },
            name: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-name') },
                update: function (val) { data = val; this.elem.textContent = data; }
            },
            description: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-desc') },
                update: function (val) { data = val; this.elem.textContent = data; }
            },
            value: {
                data: '',
                get elem() { return container.querySelector('.enquiry-object-value') },
                update: function (val) { data = val; this.elem.innerHTML = data; }
            }
        },
        update = function (updateData) {
            Object.entries(updateData).forEach(([key, value]) => { if (key in view) view[key].update(value) });
        };

    return { update: update };

}

export { Panel };